/*
 * UK9 shop assistant - the chat window (built 22 Oct 2026). Loaded by snippets/uk9-assistant.liquid.
 *
 * The shopper types what they are looking for; the AI (via our Cloudflare Worker, window.UK9_ASSISTANT.endpoint)
 * decides what to search for. The searches and product cards run HERE in the shopper's browser, against this store's
 * own public search (/search/suggest.json) and product data (/products/<handle>.js), so prices and stock are exactly
 * what the shopper sees, and Shopify's bot protection never gets in the way (it blocks datacenter requests).
 *
 * The browser holds the conversation in Anthropic message format and sends it with every step; the Worker is
 * stateless. One question = up to 6 steps (search, search again, show products, reply).
 * Measuring it: product links carry utm_source=uk9-assistant, and Add to basket sets the cart attribute
 * "Shop assistant: yes", so orders that used it can be counted.
 */
(function () {
  'use strict';
  var CFG = window.UK9_ASSISTANT || {};
  if ((!CFG.endpoint && !CFG.demo) || document.getElementById('uk9a-launch')) return;

  var MAX_STEPS = 6, MAX_CHARS = 500, STORE_KEY = 'uk9a-v1';
  var CHIPS = ['Where’s my order?', 'Senior dog food', 'Fly spray for horses', 'Layers pellets for hens', 'Wild bird seed'];
  var GREETING = "Hi 👋 Tell me briefly what you're looking for today, and I'll show you the best options.";
  var UTM = 'utm_source=uk9-assistant&utm_medium=chat';

  // ---------- state (kept for this browser tab only) ----------
  var state = { conv: '', messages: [], log: [], open: false };
  try { var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); if (saved && saved.conv) state = saved; } catch (e) {}
  if (!state.conv) state.conv = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }

  // ---------- helpers ----------
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(text) {
    return esc(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/info@uk9\.co\.uk/g, '<a href="mailto:info@uk9.co.uk">info@uk9.co.uk</a>')
      .replace(/\n/g, '<br>');
  }
  function money(pence) { return '£' + (pence / 100).toFixed(2); }
  function strip(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }
  function withUtm(url) { return url + (url.indexOf('?') > -1 ? '&' : '?') + UTM; }

  // ---------- the window ----------
  var launch = el('button', 'uk9a-launch'); launch.id = 'uk9a-launch'; launch.type = 'button';
  launch.setAttribute('aria-label', 'Open the shop assistant');
  launch.innerHTML = '<span class="uk9a-launch-icon" aria-hidden="true">🔍</span><span class="uk9a-launch-text">Help me find…</span>';

  var panel = el('div', 'uk9a-panel'); panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'UK9 shop assistant'); panel.hidden = true;
  var head = el('div', 'uk9a-head');
  var title = el('div', 'uk9a-title'); title.innerHTML = '<strong>UK9 shop assistant</strong><span>' + (CFG.demo ? 'DEMO: preview with pre-set replies' : 'Tell me what you need') + '</span>';
  var close = el('button', 'uk9a-close'); close.type = 'button'; close.setAttribute('aria-label', 'Close'); close.innerHTML = '&times;';
  head.appendChild(title); head.appendChild(close);
  var body = el('div', 'uk9a-body'); body.setAttribute('aria-live', 'polite');
  var chips = el('div', 'uk9a-chips');
  CHIPS.forEach(function (c) { var b = el('button', 'uk9a-chip', c); b.type = 'button'; b.addEventListener('click', function () { ask(c); }); chips.appendChild(b); });
  var form = el('form', 'uk9a-form');
  var input = el('input', 'uk9a-input'); input.type = 'text'; input.maxLength = MAX_CHARS; input.placeholder = 'e.g. food for an older Labrador';
  input.setAttribute('aria-label', 'What are you looking for?'); input.autocomplete = 'off';
  var send = el('button', 'uk9a-send', 'Send'); send.type = 'button'; // not type=submit: the theme restyles submit buttons
  send.addEventListener('click', function () { ask(input.value); });
  form.appendChild(input); form.appendChild(send);
  // always-visible way to reach a person (Hamish, 22 Oct: "does it give customers the option to email us")
  var foot = el('div', 'uk9a-foot');
  foot.innerHTML = '<a class="uk9a-email" href="mailto:info@uk9.co.uk?subject=' + encodeURIComponent('Question from the website') + '">Not what you needed? Email us at info@uk9.co.uk</a> and the team will help.'
    + '<span class="uk9a-small">AI assistant, so it can make mistakes. To check an order, have your order number and email address ready. Please don’t share any other personal details.</span>';
  panel.appendChild(head); panel.appendChild(body); panel.appendChild(chips); panel.appendChild(form); panel.appendChild(foot);
  document.body.appendChild(launch); document.body.appendChild(panel);

  function scrollDown() { body.scrollTop = body.scrollHeight; }
  function addBubble(who, html, record) {
    var b = el('div', 'uk9a-msg uk9a-' + who); b.innerHTML = html; body.appendChild(b); scrollDown();
    if (record !== false) { state.log.push({ t: 'msg', who: who, html: html }); save(); }
    return b;
  }
  function addCards(cards, record) {
    var wrap = el('div', 'uk9a-cards');
    cards.forEach(function (p) { wrap.appendChild(card(p)); });
    body.appendChild(wrap); scrollDown();
    if (record !== false) { state.log.push({ t: 'cards', cards: cards }); save(); }
  }
  function card(p) {
    var c = el('div', 'uk9a-card');
    var a = el('a', 'uk9a-card-link'); a.href = withUtm(p.url);
    // not lazy-loaded: only 3 small images, and lazy-loading inside the chat's scroll box left gaps
    if (p.image) { var img = el('img'); img.src = p.image; img.alt = ''; img.width = 72; img.height = 72; a.appendChild(img); }
    var info = el('div', 'uk9a-card-info');
    info.appendChild(el('div', 'uk9a-card-title', p.title));
    var price = el('div', 'uk9a-card-price'); price.innerHTML = esc(p.price) + (p.was ? ' <s>' + esc(p.was) + '</s>' : '');
    info.appendChild(price);
    if (p.reason) info.appendChild(el('div', 'uk9a-card-why', p.reason));
    if (!p.available) info.appendChild(el('div', 'uk9a-card-oos', 'Out of stock'));
    a.appendChild(info); c.appendChild(a);
    if (p.available && p.variant) {
      var add = el('button', 'uk9a-add', 'Add to basket'); add.type = 'button';
      add.addEventListener('click', function () { addToBasket(p.variant, add); });
      c.appendChild(add);
    }
    return c;
  }
  function addToBasket(variant, btn) {
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Shop assistant': 'yes' } }) }); })
      .then(function () {
        var done = el('a', 'uk9a-added', 'Added ✓ View basket'); done.href = '/cart';
        btn.replaceWith(done);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }
  function typing(on) {
    var t = document.getElementById('uk9a-typing');
    if (on && !t) { t = el('div', 'uk9a-msg uk9a-bot uk9a-typing'); t.id = 'uk9a-typing'; t.innerHTML = '<span></span><span></span><span></span>'; body.appendChild(t); scrollDown(); }
    if (!on && t) t.remove();
  }

  function restore() {
    body.innerHTML = '';
    addBubble('bot', esc(GREETING), false);
    state.log.forEach(function (x) { if (x.t === 'msg') addBubble(x.who, x.html, false); else addCards(x.cards, false); });
    chips.hidden = state.log.length > 0;
  }
  function openPanel() { panel.hidden = false; launch.hidden = true; state.open = true; save(); restore(); setTimeout(function () { input.focus(); }, 50); }
  function closePanel() { panel.hidden = true; launch.hidden = false; state.open = false; save(); launch.focus(); }
  launch.addEventListener('click', openPanel);
  close.addEventListener('click', closePanel);
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  // ?assistant=open (newsletter links, 22 Oct) opens the chat straight away
  if (state.open || /[?&]assistant=open(&|$)/.test(location.search)) openPanel();

  // ---------- the tools the AI asks for (run here, in the shopper's browser) ----------
  function searchProducts(query) {
    var q = encodeURIComponent(String(query || '').slice(0, 100));
    var u = '/search/suggest.json?q=' + q + '&resources[type]=product&resources[limit]=10'
      + '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,body';
    return fetch(u, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
      if (!ps.length) return 'No products found for "' + query + '". Try a simpler or different phrase.';
      lastFound = ps.filter(function (p) { return p.available; }).slice(0, 3).map(function (p) { return { handle: p.handle, reason: p.type || '' }; });
      return JSON.stringify(ps.map(function (p) {
        var was = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '£' + p.compare_at_price_max : undefined;
        return { handle: p.handle, title: p.title, brand: p.vendor, type: p.type, price: '£' + p.price, was_price: was,
          in_stock: !!p.available, about: strip(p.body).slice(0, 220) };
      }));
    });
  }
  function showProducts(items) {
    shownThisTurn = true;
    items = (items || []).slice(0, 3);
    return Promise.all(items.map(function (it) {
      var h = String(it.handle || '').replace(/[^a-z0-9-]/gi, '');
      if (!h) return null;
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return null;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        return { title: p.title, url: '/products/' + p.handle, image: img, price: money(v ? v.price : p.price),
          was: v && v.compare_at_price > v.price ? money(v.compare_at_price) : '', available: !!(v && v.available),
          variant: v ? v.id : null, reason: String(it.reason || '').slice(0, 90) };
      }).catch(function () { return null; });
    })).then(function (cards) {
      cards = cards.filter(Boolean);
      pending = pending.concat(cards);
      return cards.length ? 'Shown to the shopper: ' + cards.map(function (c) { return c.title + ' (' + c.price + (c.available ? '' : ', out of stock') + ')'; }).join('; ')
        : 'None of those handles could be shown. Use handles exactly as returned by search_products.';
    });
  }
  function checkOrder(input) {
    var url = String(CFG.endpoint).replace(/\/chat$/, '/order');
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ conv: state.conv, order: input && input.order_number, email: input && input.email }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { return j.result || 'The order check did not work. Ask them to email info@uk9.co.uk with the order number.'; });
  }
  // delivery charge from the canonical table (uk9-delivery-thresholds-canonical): weight band first, then spend.
  // Bands run to x.20kg, as the live shipping rates do. Done here, not by the AI, so the figure is always right.
  function deliveryCost(input) {
    var kg = +((input && input.total_weight_kg) || 0), spend = +((input && input.basket_total_gbp) || 0);
    if (!(kg > 0)) {
      // weight unknown: say what applies at this spend for each weight band, so the AI never has to reason it out
      if (!(spend > 0)) return 'Free delivery (mainland Great Britain): any basket up to 30kg is free on orders over £50; 30kg to 60kg is free over £100; 60kg to 150kg is free over £200. Below those amounts: £3.75 up to 3kg, £5.75 from 3kg to 30kg, £11.50 from 30kg to 60kg, then £17.25, £23.00 and £28.75 per 30kg band to 150kg. The exact charge is always shown in the basket.';
      var s30 = spend >= 50 ? 'FREE' : '£3.75 up to 3kg or £5.75 from 3kg to 30kg (free over £50)';
      var s60 = spend >= 100 ? 'FREE' : '£11.50 (free over £100)';
      var s150 = spend >= 200 ? 'FREE' : '£17.25 to £28.75 depending on weight (free over £200)';
      return 'With £' + spend.toFixed(2) + ' of products, delivery is: ' + s30 + ' if the basket weighs up to 30kg; ' + s60 + ' if it weighs 30kg to 60kg; ' + s150 + ' if it weighs 60kg to 150kg. Most orders of tins, pouches or small bags are under 30kg. The exact charge is always shown in the basket.';
    }
    if (input.highlands_or_islands) return kg <= 30.2 ? 'Scottish Highlands and Islands: £9.99 for up to 30kg. Free delivery is not available there.'
      : 'Scottish Highlands and Islands over 30kg: the charge is shown in the basket at checkout. Free delivery is not available there.';
    var bands = [[3, 3.75, 50], [30, 5.75, 50], [60, 11.5, 100], [90, 17.25, 200], [120, 23, 200], [150, 28.75, 200]], lo = 0;
    for (var i = 0; i < bands.length; i++) {
      var b = bands[i];
      if (kg <= b[0] + 0.2) {
        var band = (lo ? lo + 'kg to ' : 'up to ') + b[0] + 'kg';
        var free = spend >= b[2];
        return 'Total ' + kg + 'kg is in the ' + band + ' band: £' + b[1].toFixed(2) + ', or free on orders over £' + b[2] + '. '
          + (spend > 0 ? 'With £' + spend.toFixed(2) + ' of products, delivery is ' + (free ? 'FREE.' : '£' + b[1].toFixed(2) + ' (spend £' + (b[2] - spend).toFixed(2) + ' more for free delivery).') : '')
          + ' The exact charge is always shown in the basket.';
      }
      lo = b[0];
    }
    return 'Over 150kg: free delivery (on orders over £200) covers the first 150kg, and the extra weight is charged; the exact figure is shown in the basket.';
  }
  function runTool(b) {
    var p = b.name === 'search_products' ? searchProducts(b.input && b.input.query)
      : b.name === 'check_order' ? checkOrder(b.input)
      : b.name === 'delivery_cost' ? Promise.resolve(deliveryCost(b.input || {}))
      : b.name === 'show_products' ? showProducts(b.input && b.input.items)
      : Promise.resolve('Unknown tool');
    return p.catch(function () { return 'The search failed, please try a different phrase.'; })
      .then(function (out) { return { type: 'tool_result', tool_use_id: b.id, content: String(out) }; });
  }

  // ---------- one question: loop until the AI has finished replying ----------
  var busy = false, pending = [], startIdx = 0;
  // safety net (22 Oct): the AI sometimes answers a short request ("Pigeon loft") with only a question. If it searched
  // but showed nothing, show the top 3 in-stock results it found, so the shopper always sees something to tap.
  var lastFound = [], shownThisTurn = false;
  function finish(text) {
    typing(false);
    if (text) addBubble('bot', fmt(text));
    if (pending.length) addCards(pending);
    pending = []; busy = false; input.focus();
  }
  // keep the history small enough for the server limits: drop the oldest whole questions first
  function isTypedMsg(m) { return m.role === 'user' && typeof m.content === 'string'; }
  function trimHistory() {
    while (state.messages.length > 36 || JSON.stringify(state.messages).length > 55000) {
      var next = -1;
      for (var i = 1; i < state.messages.length; i++) if (isTypedMsg(state.messages[i])) { next = i; break; }
      if (next < 1) break;
      state.messages = state.messages.slice(next);
    }
  }
  function step(n) {
    if (n >= MAX_STEPS) { state.messages = state.messages.slice(0, startIdx); save(); finish('Sorry, I couldn’t pin that down. Could you put it another way?'); return; }
    fetch(CFG.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ conv: state.conv, page: location.pathname, messages: state.messages }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw res;
        var content = res.j.content || [];
        state.messages.push({ role: 'assistant', content: content }); save();
        var text = content.filter(function (b) { return b.type === 'text'; }).map(function (b) { return b.text; }).join('\n').trim();
        var calls = content.filter(function (b) { return b.type === 'tool_use'; });
        if (res.j.stop_reason === 'tool_use' && calls.length) {
          return Promise.all(calls.map(runTool)).then(function (results) {
            state.messages.push({ role: 'user', content: results }); save();
            step(n + 1);
          });
        }
        if (!shownThisTurn && lastFound.length) { var fallback = lastFound; lastFound = []; return showProducts(fallback).then(function () { finish(text); }); }
        finish(text);
      })
      .catch(function (err) {
        // forget the unanswered question entirely, so the history stays valid for the next one
        state.messages = state.messages.slice(0, startIdx); pending = []; save();
        var code = err && err.j && err.j.error;
        finish(code === 'slow_down' ? 'One moment, that was a lot of questions at once. Please try again in a minute.'
          : (code === 'day_limit' || code === 'conv_limit') ? 'That’s as many questions as I can answer for now. For anything else, please email info@uk9.co.uk and the team will help.'
          : 'Sorry, I’m having trouble right now. Please try again, or use the search at the top of the page.');
      });
  }

  // ---------- DEMO MODE (CFG.demo): no AI and no cost. Real search and real product cards, pre-set wording. ----------
  // Used on the preview theme so Hamish and Krista can see it before any spend. The real version is smarter than this.
  var DEMO = {
    'senior dog food': { q: 'senior dog food', say: 'Here are three popular senior foods. Tell me your dog’s size, or whether you’d like dry or wet, and I’ll narrow it down.' },
    'fly spray for horses': { q: 'horse fly spray', say: 'Here are three fly repellents for horses. If you’d like a natural option or a bigger bottle, just say.' },
    'layers pellets for hens': { q: 'layers pellets', say: 'Here are three layers pellets for hens. Would you like organic, or a smaller bag?' },
    'wild bird seed': { q: 'wild bird seed', say: 'Here are three wild bird mixes. If it’s mostly robins and small songbirds, I can suggest something more specific.' }
  };
  function demoAnswer(text) {
    if (/where.?s my order|where is my order|track|tracking|order status|my order/i.test(text)) {
      setTimeout(function () { finish('In the full version I’d ask for your order number and the email you ordered with. Then I’d tell you what’s been dispatched, what’s waiting for stock, and give you the tracking link.'); }, 700);
      return;
    }
    var hit = DEMO[text.toLowerCase()];
    var q = hit ? hit.q : text;
    var words = q.split(/\s+/);
    function tryQuery(query) {
      return searchProducts(query).then(function (out) {
        var list = []; try { list = JSON.parse(out); } catch (e) {}
        list = list.filter(function (p) { return p.in_stock; }).slice(0, 3);
        if (!list.length && words.length > 1) { words.pop(); return tryQuery(words.join(' ')); }
        return list;
      });
    }
    setTimeout(function () {
      tryQuery(q).then(function (list) {
        if (!list.length) { finish('I couldn’t find that one. Try different words, or email info@uk9.co.uk and the team will see if they can get it for you.'); return; }
        return showProducts(list.map(function (p) { return { handle: p.handle, reason: p.type }; })).then(function () {
          finish(hit ? hit.say : 'Here’s what I found. Tell me a bit more, such as size, age or budget, and I’ll narrow it down.');
        });
      }).catch(function () { finish('Sorry, something went wrong. Please try again.'); });
    }, 700);
  }
  function ask(text) {
    text = String(text || '').trim().slice(0, MAX_CHARS);
    if (!text || busy) return;
    busy = true; chips.hidden = true; input.value = ''; pending = []; lastFound = []; shownThisTurn = false;
    addBubble('user', esc(text));
    if (CFG.demo) { typing(true); demoAnswer(text); return; }
    trimHistory();
    startIdx = state.messages.length;
    var context = '[Page the shopper is on: ' + (document.title || '').slice(0, 100) + ']\n';
    state.messages.push({ role: 'user', content: context + text }); save();
    typing(true); step(0);
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
})();
